(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const buyNowBtn = document.querySelector('[data-buy-now]');
    const form = document.querySelector('form[action*="/cart/add"]');

    if (!buyNowBtn || !form) return;

    buyNowBtn.addEventListener('click', async () => {
      try {
        // 1️⃣ Clear cart
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
        });

        // 2️⃣ Add product
        const formData = new FormData(form);
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });

        // 3️⃣ Go to checkout
        window.location.href = '/checkout';
      } catch (error) {
        console.error('Buy Now failed:', error);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
